<template>
<div class="page4">
   <div class="box">
     <div style="width: 71%;min-width: 204px;">为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停⻋管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</div>
   </div>
  <div class="box1"><img src="../../assets/img/h4.png" alt=""></div>
  <div class="box2 lll"><img class="ert" src="../../assets/img/hy.png" alt=""></div>


</div>
</template>
<script>
export default {
  name: "page4",
  data () {
    return {

    };
  }
}
</script>
<style scoped>
 html{
   font-size:1vw;
 }
.box{
   font-size: 0.832rem;
       line-height: 1.664rem;
   
       text-align: left;
      width: 39.5%;
      margin-top: 3.016rem;
      position:relative ;
}
.box1{
  width: 27.5%;
  height: 9.36rem;
}
.lll{
  height: 12.688rem;
}

.page4 img{
  width: 100%;
}
.box2{
  position: absolute;
  top: 13.5rem;
  left: 31%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/page4.vue